module.exports = __webpack_public_path__ + "img/banner1.ebec38c.png";